import cpdActivityDetails from './cpd-activity-details';
import totalUserCpdProgress from './total-user-cpd-progress';

const cpdActivityReport = ({ cpdActivity, progressTableRows, ...data }) => [
  ...totalUserCpdProgress({
    ...data,
    progressTableRows
  }),
  ['addPage'],
  ...cpdActivityDetails({
    ...data,
    cpdActivity
  })
];

export default cpdActivityReport;



// WEBPACK FOOTER //
// ./src/reports/cpd-activity.js